import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

const baseUri = '/api/platform/markets/config/v1'
type EmptyMapping = Record<string, never>

export type TenantCommodity = {
  id: string
  displayName: string
  sourceId: string
}

export type MappingStatus =
  | { type: 'mapped'; data: { sourceId: string; name: string } }
  | { type: 'perLocationComplete'; data: EmptyMapping }
  | { type: 'perLocationPartiallyComplete'; data: EmptyMapping }
  | { type: 'unmapped'; data: EmptyMapping }

export type MappingListItem = {
  commodityId: string
  commodityName: string
  mappingStatus: MappingStatus
}

export type MappingLocation = {
  locationId: string
  locationName: string
  tenantCommodity: TenantCommodity | null
}

export type CommodityMapping =
  | { type: 'global'; data: { tenantCommodity: TenantCommodity } }
  | { type: 'perLocation'; data: EmptyMapping }
  | { type: 'unmapped'; data: EmptyMapping }

export type MappingDetails = {
  commodityId: string
  commodityName: string
  mapping: CommodityMapping
  locationMappings: MappingLocation[]
}

export type UpdateCommodityMapping =
  | { type: 'global'; data: { tenantCommodityId: string } }
  | {
      type: 'perLocation'
      data: { mappings: Array<{ locationId: string; tenantCommodityId: string }> }
    }
  | { type: 'unmapped'; data: EmptyMapping }

export type UpdateCommodityMappingRequest = {
  commodityId: string
  mapping: UpdateCommodityMapping
}

const tenantHeaders = (tenantId: string) => ({ 'X-Bushel-Tenant': tenantId })

export const GetTenantCommodityMappings = async (
  data: { datasourceId: string },
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/GetTenantCommodityMappings`, data, {
      headers: tenantHeaders(tenantId),
    })
  )

export const GetTenantCommodityMappingDetails = async (
  data: { commodityId: string },
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/GetTenantCommodityMappingDetails`, data, {
      headers: tenantHeaders(tenantId),
    })
  )

export const UpdateTenantCommodityMapping = async (
  data: UpdateCommodityMappingRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/UpdateTenantCommodityMapping`, JSON.stringify(data), {
      headers: { ...tenantHeaders(tenantId), 'Content-Type': 'application/json' },
    })
  )
